import dayjs from 'dayjs/esm/index.js'
import dayjsUTC from 'dayjs-plugin-utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezonePlugin from 'dayjs/plugin/timezone';
import 'dayjs/locale/es';

export const importPlugins = () => {
    dayjs.extend(dayjsUTC);
    dayjs.extend(timezonePlugin);
    dayjs.extend(customParseFormat);
}

// current date
export const now = (offset = false) => {

    if(offset){
        return dayjs();
    }
    else{
        importPlugins();
        return dayjs().utc();
    }
}

// to return current date depending on the time type
export const nowByType = (type, offset = false) => {

    let returnTime;

    const nowTime = now(offset);

    switch(type){

        case 'date': // to format the date without hour
            returnTime = nowTime.format('YYYY-MM-DD');
            break;
        
        case 'hour': // to format only with hour
            returnTime = nowTime.format('HH:mm');
            break;

        case 'datetime_offset': // to format the date with hour and offset
            returnTime = nowTime.toISOString();
            break;

        case 'datetime': // to format the date with hour            
        default:
            returnTime = nowTime.format('YYYY-MM-DD HH:mm:ss');
            break;

    }

    return returnTime;
}


// check valid database date
export const validDBdate = (date) => {

    if(
        !date || 
        !dayjs(date).isValid() ||
        date === '' || 
        date === '0000-00-00' || 
        date === '0000-00-00 00:00:00' ||
        date === '0000-00-00T00:00:00.000000Z'
    ){
        return false;
    }

    return true;
}

// created_at and updated_at from database have this format
// 2025-07-16T09:00:00.000000Z
// change to 2025-07-16T09:00:00
export const dbDateWithTimezoneToDbDate = (date) => {

    importPlugins();

    if(!validDBdate(date)){
        return '';
    }

    var dateUTC = dayjs.utc(date);
    var format = 'YYYY-MM-DD HH:mm:ss';

    return dayjs(dateUTC).format(format);
}

// from database to format
export const date = (date, hour = false, timezone = false) => {

    importPlugins();

    if(!validDBdate(date)){
        return '';
    }
    
    var dateUTC = dayjs.utc(date);
   
    var format = '';

    // if only year YYYY
    var dateRegex = /^\d\d\d\d$/;   
    if(dateRegex.test(date)){
        return date;
    }
    else{
        // if year and month YYYY-MM
        dateRegex = /^\d\d\d\d-\d\d$/;   
        if(dateRegex.test(date)){
            format = "MM/YYYY";
        }
        else{
            format = "DD/MM/YYYY";
        }
    }

    if(hour){
        format = format+" HH:mm:ss";
    }

    if(timezone){
        var timezoneDaysjs = dayjs.tz.guess();

        // without locale('es') it shows MM/DD/YYYY regardless the format parameter
        return dayjs(dateUTC).tz(timezoneDaysjs).locale('es').format(format);
    }
    else{
        return dayjs(dateUTC).format(format);
    }
}

// format dates on the ag grid
export const dateFormatter = (params,table,column,hour,timezone) => {
    const dateString = params.value;
    return date(dateString,hour,timezone);
}

// comparator for dates
// date1 < date2 => 1, date1 = date2 => 0, date1 > date2 => -1
export const datesComparator = (dateFilter,dateValue,format = 'YYYY-MM-DD') => {

    var result = 0;
        
    if(!validDBdate(dateFilter)){
        
        if(!validDBdate(dateValue)){
            result = 0;
        }
        else{
            result = 1; // empty goes before any date
        }
    }
    else{
        if(!validDBdate(dateValue)){
            result = -1; // empty goes before any date
        }
        else{
            
            importPlugins();

            // modify the input string, setting the offset to +0
            const dateFilterString = dateFilter.toString();
            const dateFilterConvertion = new Date(dateFilterString.replace(/GMT.*$/,'GMT+0000')).toISOString();

            //const dateFilterConvertion = new Date(dateFilter).toString();
            const date1js = dayjs(dateFilterConvertion,format);
            const date2js = dayjs(dateValue,format);

            if(date1js.isBefore(date2js)){
                result = 1;
            }
            else{
                if(date1js.isAfter(date2js)){
                    result = -1;
                }
                else {
                    result = 0;
                }
            }
        }
    }

    return result;
}
